import {AUTH_LOGOUT_EVENT, bootRefreshPromise, clearMemoryToken, storeTokens} from "api";
import {STAuthResponse} from "api/types";
import Loader from "components/Plugins/Loader";
import {BROADCAST_CHANNELS} from "helpers/BroadcastChannel/BroadcastChannels";
import {useBroadcastState} from "hooks/useBroadcastState";
import {useCallback, useEffect, useRef, useState} from "react";
import {useDispatch} from "react-redux";
import {logout} from "store/user/userSlice";

const TokenRefreshCheck = () => {
	const dispatch = useDispatch();

	// Capture the promise reference at first render — the module sets it to null
	// once resolved, so we need the original reference to attach our handler.
	const promiseRef = useRef(bootRefreshPromise);
	const [isBooting, setIsBooting] = useState(promiseRef.current !== null);

	useEffect(() => {
		const promise = promiseRef.current;

		if (promise) {
			promise.finally(() => setIsBooting(false));
		}
	}, []);

	useEffect(() => {
		const handleAuthLogout = () => {
			clearMemoryToken();
			dispatch(logout());
		};

		window.addEventListener(AUTH_LOGOUT_EVENT, handleAuthLogout);

		return () => window.removeEventListener(AUTH_LOGOUT_EVENT, handleAuthLogout);
	}, [dispatch]);

	const handleAuthBroadcast = useCallback((newState: STAuthResponse) => {
		storeTokens(newState);
	}, []);

	useBroadcastState<STAuthResponse>(BROADCAST_CHANNELS.AUTH_TOKEN, handleAuthBroadcast);

	if (isBooting) {
		return <Loader displayAtCenterOfPage />;
	}

	return null;
};

export default TokenRefreshCheck;
